// This hook runs a listener that verifies the screen size and returns 2 values:
// maxBreakpoint => returns true if it's AT OR BELOW the variable passed in
// exactBreakpoint => returns true if it's AT the exact variable passed in
// The `query` variable passed in should be the value that represents
// the exact breakpoint min size. It's retrieved from the `rawBreakpoints` object.

import { useEffect, useState } from 'react'
import { rawBreakpoints } from '@redriverpress/system'

import useDebounce from 'Common/hooks/useDebounce'

const defaultPixel = 16
const { sm, md, lg, xl } = rawBreakpoints

export default function useIncludedMediaQuery(query = null) {
  const [mediaQuery, setMediaQuery] = useState(null)

  const debounceGetBreakpoint = useDebounce(
    () => {
      const windowSize = window?.innerWidth / defaultPixel || null
      if (windowSize < sm) {
        setMediaQuery(sm)
        return
      }
      if (windowSize < md) {
        setMediaQuery(sm)
        return
      }
      if (windowSize < lg) {
        setMediaQuery(md)
        return
      }
      if (windowSize < xl) {
        setMediaQuery(lg)
        return
      }
      if (windowSize >= xl) {
        setMediaQuery(xl)
      }
    },
    300,
    true
  )

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', debounceGetBreakpoint)
      debounceGetBreakpoint()

      return () => window.removeEventListener('resize', debounceGetBreakpoint)
    }
  }, [window])

  const maxBreakpoint = query ? mediaQuery <= query : mediaQuery
  const exactBreakpoint = query ? mediaQuery === query : mediaQuery

  return { maxBreakpoint, exactBreakpoint }
}
